import React, { FC } from 'react';

import { Uuid }                                                                                  from "@src/types";
import { ENTITY_ICONS }                                                                          from "@src/constants/ProductEnums";
import { ProjectActivityBulkUpdateShellFormContainerProps, ProjectActivityBulkUpdateShellProps } from "@src/views/pages/projects/activities/bulk/ProjectActivityBulkUpdateShell";
import { ProjectActivityBulkUpdateMultiDialogProps }                                             from "@src/views/pages/projects/operations/ProjectActivityBulkUpdateMultiDialog";
import { ProjectActivityBulkUpdateCostAttribute }                                                from "@src/views/pages/projects/activities/bulk/slices/ProjectActivityBulkUpdateCostAttribute";


type FormTypeAttributes = {
    costType: Uuid | null,
    operationalCostOverride: number | null
}

interface ProjectActivityBulkUpdateOperationalCostProps extends Pick<ProjectActivityBulkUpdateShellProps<FormTypeAttributes>, 'supportModals' | 'supportToasts'>,
    Pick<ProjectActivityBulkUpdateMultiDialogProps, 'projectId' | 'projectVersionId' | 'projectActivityIds'> {
    formContainer: FC<ProjectActivityBulkUpdateShellFormContainerProps>
}

const ProjectActivityBulkUpdateOperationalCostDefaultProps = {
    supportModals: false,
    supportToasts: true,
} satisfies Partial<ProjectActivityBulkUpdateOperationalCostProps>

function ProjectActivityBulkUpdateOperationalCost( _props: ProjectActivityBulkUpdateOperationalCostProps ){

    const props = { ...ProjectActivityBulkUpdateOperationalCostDefaultProps, ..._props };

    return (

        <ProjectActivityBulkUpdateCostAttribute
            { ...props }
            attributeName={ 'operationalCostOverride' }
            icon={ ENTITY_ICONS.BUDGET.OPERATIONAL_COSTS }
            title={ 'Update Operational Cost' }
            description={ `Define a custom operational cost for multiple activities. Activities with professional fees assigned will have their costs overwritten to the single cost below.` }
            fieldLabel={ 'Operational Cost' }
            fieldDescription={ 'The operational cost assigned to each of the selected activities.' }/>

    );
}

export {
    ProjectActivityBulkUpdateOperationalCost,
    ProjectActivityBulkUpdateOperationalCostDefaultProps,
    type ProjectActivityBulkUpdateOperationalCostProps,
};
